import {
  indexLayoutSidebar,
  leftWidth,
  rightWidth,
  canvasFirstRightWidth,
  leftMaxWidth,
} from '@sketch/constants'

export const sidebar = {
  indexLayoutSidebar,
  leftWidth,
  leftMaxWidth,
  rightWidth,
  canvasFirstRightWidth,
} as const
